import styles from './aboutUs.module.scss'
import { Text } from 'typography/text'
import { PageSection } from 'layout/pageSection'
import { Container } from 'layout/container'

const AboutUsSection = () => {
  return (
    <PageSection id={'about-us'}>
      <Container className={styles.aboutUs__wrapper} noPadding="md">
        <div className={`${styles.aboutUs} inverted`}>
          <div className={`${styles.aboutUs__textBlock}`}>
            <h2 className={`h2 ${styles.aboutUs__title}`}>About Us</h2>
            <Text>
              <p>
                <b>Discount Air Travel Made Simple!</b> Here at Discount Fares, our mission as
                travel experts is simple. We want to provide our clients with the best solutions for
                planning and managing their air travel. Our main objective has been to partner up
                with accredited, licensed travel agencies who can provide our clients with real
                discounted airfares. During our research, we found plenty of websites selling
                airfares at sky-high prices, whose discounts are only available to agencies,
                wholesalers, and consolidators! We did not find many that offer discounted options
                to travelers directly. So our mission here at Discount Fares is to connect our
                clients to those offering the best deals around. All of the agencies we work with
                are bonded with major travel associations and institutions that are distinct with
                high quality and recommendation scores.{' '}
                <b>Save time, save money, save the hassle.</b>
              </p>
            </Text>
          </div>
          <img
            src="/static/img/aboutUs/agent.jpg"
            className={`${styles.aboutUs__imgBlock}`}
            alt=""
          />
        </div>
      </Container>
    </PageSection>
  )
}

export { AboutUsSection }
